import ProductDisplayPage from '@/components/ProductDisplayPage';
import { ProvideFullScreenLoader } from '@/hooks/useFullScreenLoader';
import { Container } from '@mui/material';
import Footer from '@/components/Footers';
import BaseLayout from '@/layouts/BaseLayout';

function PDP() {
	return (
		<ProvideFullScreenLoader>
			<ProductDisplayPage />
		</ProvideFullScreenLoader>
	);
}

export default PDP;

PDP.getLayout = function getLayout(page: any) {
	return (
		<>
			<BaseLayout>
				<Container maxWidth='lg'>{page}</Container>
			</BaseLayout>
			<Footer />
		</>
	);
};
